import { MDSBannerKind, MDSButtonVariant } from "@/mds";
import { MdsIconKind } from "@/design-system/components/icon";
import { FeatureGateBannerQuotaLevel } from "./feature-gate-banner.types";

export interface FeatureGateBannerConfig {
  bannerKind: MDSBannerKind;
  message: string;
  buttonVariant: MDSButtonVariant;
  buttonText: string;
  iconKind: MdsIconKind;
}

export const getFeatureGateBannerConfig = (
  level: FeatureGateBannerQuotaLevel
): FeatureGateBannerConfig => {
  switch (level) {
    case FeatureGateBannerQuotaLevel.Exceeded:
      return {
        bannerKind: MDSBannerKind.Error,
        message: "You've reached your free usage limits this month",
        buttonVariant: MDSButtonVariant.Danger,
        buttonText: "Upgrade to Pro",
        iconKind: MdsIconKind.InfoCircle,
      };
    case FeatureGateBannerQuotaLevel.Warning:
    default:
      return {
        bannerKind: MDSBannerKind.Info,
        message: "You’re nearing your free usage limits this month",
        buttonVariant: MDSButtonVariant.Transparent,
        buttonText: "Upgrade to Pro",
        iconKind: MdsIconKind.InfoCircle,
      };
  }
};
